// Страница Кубикон CAD.
// Маршруты:
//   /main/cad-editor         — список проектов (Мои + Лента) — НЕ полноэкранно
//   /main/cad-editor/new     — редактор нового проекта (полноэкранно)
//   /main/cad-editor/:id     — редактор существующего проекта (полноэкранно)
//
// Полноэкранный режим: документу добавляется класс body.kubcad-fullscreen,
// глобальные CSS скрывают Header/Footer/Menu и растягивают редактор.

import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import KubikonCAD from '../../components/KubikonCAD/KubikonCAD';
import CadProjectsPage from '../../components/KubikonCAD/CadProjectsPage';
import DesktopOnlyGuard from '../../components/UI/DesktopOnlyGuard/DesktopOnlyGuard';
import CadErrorBoundary from '../../components/KubikonCAD/CadErrorBoundary';

const KubikonCADPage = ({ isNew, feedTab }) => {
    const { id } = useParams();
    // Урок передаётся в адресе: /main/cad-editor/new?lesson=fp-01-space.
    // Так ссылка на урок остаётся живой — её можно дать ребёнку, сохранить
    // в закладки, вернуться из курса в ту же задачу.
    const [searchParams] = useSearchParams();
    const lessonId = searchParams.get('lesson');
    const editingId = isNew ? null : id;
    const showEditor = isNew || !!id;

    // Полноэкранный режим — только когда открыт редактор (не picker).
    useEffect(() => {
        if (!showEditor) return;
        document.body.classList.add('kubcad-fullscreen');
        return () => document.body.classList.remove('kubcad-fullscreen');
    }, [showEditor]);

    // На picker'е заглушку для мобилы не вешаем — список можно листать.
    if (!showEditor) {
        return <CadProjectsPage initialTab={feedTab ? 'feed' : 'my'}/>;
    }

    return (
        <DesktopOnlyGuard
            icon="🧊"
            title="3D-редактор только на компьютере"
            description={
                'Кубикон CAD — это полноценный профессиональный 3D-редактор.\n' +
                'Здесь нужны мышь, клавиатура и широкий экран — на телефоне работать невозможно.'
            }
        >
            {/* Перехватчик: без него ЛЮБАЯ ошибка рендера роняет всё дерево
                в пустоту, и остаётся только заставка «Загружаю редактор…» —
                именно так выглядели падения при работе с эскизом. */}
            <CadErrorBoundary>
                <KubikonCAD projectId={editingId} lessonId={lessonId}/>
            </CadErrorBoundary>
        </DesktopOnlyGuard>
    );
};

export default KubikonCADPage;
